<template>
  <div class="w-full items-center flex pt-4 pb-2 px-6">
    <div class="pl-4 my-auto flex">
      <v-menu offset-y>
        <template #activator="{ on }">
          <button data-vs-button="sort-opts" class="ml-1 focus:outline-none" v-on="on">
            <span class="text-zt-dark-300 font-medium pl-1">{{
              labelSortOptions
              }}</span>
            <zt-icon class="text-zt-dark-300 pl-2 pb-1" name="caret-down" />
          </button>
        </template>
        <v-list id="documents-search-orderbyfilter">
          <v-list-tile @click="setSortOption(option)" :class="isSortSelected(option.id)"
            v-for="(option, index) in sortOpts" :key="index">
            {{ option.name }}
          </v-list-tile>
        </v-list>
      </v-menu>
      <div class="pl-3">
        <button data-vs-button="order-filter" id="documents-search-orderbyorderfilter"
          class="flex items-baseline focus:outline-none" @click="setOrderTypeSelected">
          <zt-icon class="text-zt-primary-200" :name="orderTypeIcon" />
          <span class="pl-2 font-bold text-zt-dark-300">{{
            store.orderType === 'desc' ? $t("message.myTeam.desc") : $t("message.myTeam.asc")
          }}</span>
        </button>
      </div>
    </div>
    <div class="ml-auto">
      <template v-if="!downloadSelected">
        <zt-button data-vs-button="documents-download" gtm-class="zt-gtm-documents-search-documentsdownload"
          icon="box-arrow-down" @click="$emit('download-selected')" outlined :loader="loader"
          :loaderTxt="$t('message.inicioComponent.downloading')">{{ $t("message.inicioComponent.downloadSelected")
          }}</zt-button>
      </template>
      <template v-else>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <zt-button data-vs-button="download" :loader="loaderList"
              :loaderTxt="$t('message.inicioComponent.downloading')" outlined v-on="on" icon="box-arrow-down">
              {{ $t("message.DownloadAllDocuments.downloadAll") }}
            </zt-button>
          </template>
          <v-list>
            <v-list-tile id="documents-search-formsdatadownload" v-if="store.eforms.length > 0"
              @click="active = !active">
              <v-list-tile-title>{{ t$("message.workflow.digitalForm") }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile id="documents-search-documentsdatadownload" @click="downloadExcel">
              <v-list-tile-title>{{ $t("message.workflow.sheetResult") }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </template>
      <zt-modal max-width="700px" :active="active" @close="active = false">
        <template slot="modal-header">
          <div class="p-4">
            <span class="text-zt-xl font-bold">{{ $t("message.workflow.digitalFormData") }}</span>
          </div>
        </template>
        <div class="">
          <div class="px-6">
            <p>
              {{ $t("message.workflow.allFormResult") }}
            </p>
            <p>
              {{ $t("message.workflow.csvFormat") }}
            </p>
          </div>
          <div>
            <div class="px-6 text-black font-bold py-4 flex justify-between">
              <span>{{ $t("message.workflow.templateName") }}</span>
              <span>{{ $t("message.workflow.downloadData") }}</span>
            </div>
            <div class="list--container">
              <div v-for="eform in store.eforms" :key="eform.id" class="px-6 list--item flex justify-between py-6">
                <p>{{ eform.name }}</p>
                <div class="relative loader--container">
                  <button data-vs-button="download-metadata" v-if="!isLoadingActive(eform.id)"
                    @click="downloadMetadata(eform.id)" class="focus:outline-none text-zt-primary-200 text-zt-xl">
                    <zt-icon name="box-arrow-down" />
                  </button>
                  <vue-loading v-show="isLoadingActive(eform.id)" :active="isLoadingActive(eform.id)" color="#4f41a3"
                    :is-full-page="false" :width="20" :height="20" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </zt-modal>
    </div>
  </div>
</template>

<script>
import Search from '@/apiClient/Search'
import { filter, includes } from 'lodash'
import addGTMClass from '@/utils/addGTMClass'

export default {
  name: 'SearchTableHeader',
  props: ['downloadSelected', 'loader'],
  inject: ['store', 'setOrderBy', 'setOrderType'],
  data() {
    return {
      searchConfig: new Search(),
      active: false,
      sortOpts: [
        {
          id: 'employee',
          name: this.$t("message.LicensesManager.search.lastnameName")
        },
        {
          id: 'fiscalId',
          name: this.$t('message.label.dni')
        },
        {
          id: 'signStatus',
          name: this.$t("message.LincensesHistorySummaryComponent.labels.status")
        },
        {
          id: 'id',
          name: this.$t("message.workflow.creationDate")
        },

        {
          id: 'location',
          name: this.$t("message.LicensesManager.search.location")
        },
        {
          id: 'period',
          name: this.$t("message.workflow.period")
        },
        {
          id: 'sector',
          name: this.$t("message.workflow.sector")
        },
        {
          id: 'name',
          name: this.$t("message.documentComponent.filters.combobox.documentTypes")
        }
      ],
      gtmIds: [
        'documents-search-formsdatadownload',
        'documents-search-documentsdatadownload',
        'documents-search-orderbyfilter',
        'documents-search-orderbyorderfilter'
      ],
      loaderList: false,
      loadersArr: []
    }
  },
  mounted() {
    addGTMClass(this.gtmIds)
  },
  methods: {
    async downloadExcel() {
      this.loaderList = true

      const { filters, orderBy, orderType } = this.store

      const params = `orderBy=${orderBy}&orderType=${orderType}`

      const { data } = await this.searchConfig.DownloadExcel(filters, params)

      const newBlob = new Blob([data], { type: 'application/vnd.ms-excel' })

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob)
        return
      }

      const urlFile = window.URL.createObjectURL(newBlob)
      const link = document.createElement('a')
      link.href = urlFile
      link.download = 'Documentos.xls'
      link.click()

      this.loaderList = false
      setTimeout(function () {
        window.URL.revokeObjectURL(urlFile)
      }, 100)
    },
    async downloadMetadata(id) {
      this.loadersArr.push(id)

      const { data } = await this.searchConfig.DownloadMetadata(id)

      const newBlob = new Blob([data], { type: 'application/vnd.ms-excel' })

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob)
        return
      }

      const urlFile = window.URL.createObjectURL(newBlob)
      var link = document.createElement('a')
      link.href = urlFile
      link.download = `${id}.xls`
      link.click()

      this.loadersArr = filter(this.loadersArr, idLoader => idLoader !== id)

      setTimeout(function () {
        window.URL.revokeObjectURL(urlFile)
      }, 100)
    },
    setSortOption(option) {
      if (this.sortSelected === option.id) {
        return this.setOrderBy('id')
      }
      this.setOrderBy(option.id)
    },
    setOrderTypeSelected() {
      const { orderType } = this.store

      const newOrderType = orderType === 'desc' ? 'asc' : 'desc'

      this.setOrderType(newOrderType)
    }
  },
  computed: {
    sortSelected() {
      return this.store.orderBy
    },
    isSortSelected() {
      return id =>
        this.sortSelected === id ? 'bg-zt-primary-200 text-white' : ''
    },
    labelSortOptions() {
      if (this.sortSelected !== 'id') {
        const option = filter(
          this.sortOpts,
          opt => opt.id === this.sortSelected
        )

        return option[0].name
      }

      return this.$t("message.workflow.creationDate")
    },
    orderTypeIcon() {
      return this.store.orderType === 'desc' ? 'arrow-down' : 'arrow-up'
    },
    isLoadingActive() {
      return id => includes(this.loadersArr, id)
    }
  }
}
</script>
<style scoped>
.list--container {
  max-height: 650px;
  overflow-y: auto;
}

.list--item {
  border-top: 0.5px solid #b5b5b5;
  border-bottom: 0.5px solid #b5b5b5;
}

.loader--container {
  height: 20px;
  width: 20px;
}
</style>
